<template>
  <div class="container-fluid im-fluid" @click="$root.hideMenu">
    <h2 class="im-title">{{ $t("breadcrumbs.delivery") }}</h2>

    <div class="row">
      <div class="col-12 col-sm-12 col-xl-9">
        <a name="1"></a>

        <p>
          <strong>Delivery Policy (for Services)</strong>
        </p>

        <p>
          Upon receipt of your order, the services will be performed to you in accordance with the
          terms applicable to the services that you purchased. The nature of the services you
          purchased and the date of your purchase may impact the timing of performance of the
          services. The services will be deemed to be successfully delivered to you upon performance
          of the services.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "DeliveryPolicySection",
  };
</script>
